import type { FaireProductEntity } from "../../entity_types/product";

export const p_drhxxakxe9: FaireProductEntity = {
  token: "p_drhxxakxe9",
  type: "product",
  name: "LENNY & LARRY'S COMPLETE COOKIE 12/4Z BIRTHDAY CAKE",
  brandToken: "b_ktcqb4hfg7",
  brandName: "L&F Universal Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/40c8bc7d6b0a1e58bde2df03d8c068753992dff22bf37dabcfbd73685b0e4394.png",
  galleryImageUrls: [],
  priceDollars: 45.55,
  description:
    "Celebrating the joy of a birthday in every bite, this cookie is adorned with colorful sprinkles and infused with a sweet, cake-like flavor. It provides 16 grams of plant-based protein and 10 grams of fiber per serving, offering a guilt-free indulgence. As with all Complete Cookies, the Birthday Cake flavor is Non-GMO Project Verified, Vegan, and Kosher-friendly, free from dairy, soy, eggs, high fructose corn syrup, and artificial sweeteners.",
  tags: [],
  msrpDollars: 68.31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:32.700Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
